/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBurgerViewProps } from './burger';
import CSS from 'csstype';

const navstylehidden: CSS.Properties = {
    display: "none"
}

const navstyleshown: CSS.Properties = {
    display: "block"
}

export function icon() {
 
    return  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 283.426 283.426" xmlSpace="preserve">
        <g>
            <rect x="0" y="40.84" width="283.426" height="47.735" />
            <rect x="0" y="117.282" width="283.426" height="47.735" />
            <rect x="0" y="194.851" width="283.426" height="47.735" />
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
    </svg>
}

export default (props: IBurgerViewProps) => {
    const [ isOpen , setIsOpen ] = React.useState<boolean>(false);
   
    const toogle = () => { 
        setIsOpen(!isOpen);
    }

    return (
        <div className={"burgertime " + (props.config.className?? '')}>
            <div className="bun" onClick={toogle}>
            {icon()}
            </div>
            <div className={"toppings " + (isOpen ? 'open' : '')} style={isOpen ? navstyleshown : navstylehidden}>
            {props.slots.navigationLinks}
            {props.slots.socials}
            </div>           

        </div>
    );
};

